export const INFINITE_SCROLL_ITEMS_PER_PAGE = 50;
export const INFINITE_SCROLL_PRELOAD_PERCENTAGE = 0.9;
export const INFINITE_SCROLL_DEBOUNCE_TIME = 200;
export const INFINITE_SCROLL_THRESHOLD = 100;
